export const SortIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16" fill="none" {...props}>
        <path
            d="M8.48 4.28L7.77 4.98L4.73 1.94V16H3.73V1.96L0.7 4.98L0 4.28L3.53 0.74L4.24 0.03L4.95 0.74L8.48 4.28Z"
            fill="currentColor"
        />
        <path
            d="M15.98 11.72L12.45 15.25L11.74 15.96L11.04 15.26H11.03L7.5 11.72L8.21 11.01L11.25 14.06V0H12.25V14.04L15.28 11.01L15.98 11.72Z"
            fill="currentColor"
        />
    </svg>
);
